<template>
    <div>
        <v-card class="elevation-2">
            <v-card-title class="blue-grey darken-4 white--text">
                Lista de pedidos
                <v-btn
                    class="ml-3"
                    small
                    color="success"
                    :href="`/admin/export-sales?search=&states=${JSON.stringify([])}&date_init=&date_end=&user=seller`"
                    v-if="typeResp=='sales'"
                >Exportar</v-btn>
                <v-btn
                    class="ml-3"
                    small
                    color="success"
                    :href="`/admin/export-presales?search=&states=${JSON.stringify([])}&date_init=&date_end=&user=presale`"
                    v-if="typeResp=='presales'"
                >Exportar</v-btn>
                <v-spacer></v-spacer>
                <v-btn @click="scroll_left" fab small>
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn @click="scroll_right" fab small>
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text v-if="show">
                <v-simple-table v-if="typeResp=='sales'">
                    <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left">
                                #
                            </th>
                            <th class="text-left">
                                Acciones
                            </th>
                            <!-- <th class="text-left">
                                Estado
                            </th> -->
                            <th class="text-left" style="min-width:150px">
                                Fecha
                            </th>
                            <th class="text-left">
                                Cliente
                            </th>
                            <th class="text-left">
                                Celular
                            </th>
                            <th class="text-left" style="min-width:200px">
                                Tipo de pedido
                            </th>
                            <th class="text-left blue-grey lighten-4" style="min-width:200px" v-for="(art, j) in maxProds" :key="j">
                                Artículo {{ j+1 }}
                            </th>
                            <th class="text-right" style="min-width:100px">
                                total
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in listOrders" :key="index">
                            <td>{{ item.number }}</td>
                            <td>
                                <div class="d-flex">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                icon
                                                @click="addProducts(item.id)"
                                            >
                                                <v-icon color="grey">
                                                    mdi-basket-plus
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Añadir productos</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                icon
                                                :href="`/admin/print-sale/${item.id}`"
                                                target="_blank"
                                            >
                                                <v-icon color="grey">
                                                    mdi-printer
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Imprimir</span>
                                    </v-tooltip>
                                </div>
                            </td>
                            <!-- <td>
                                <v-chip v-if="item.state=='Nuevo'" class="white--text" color="blue" small>
                                    {{ item.state }}
                                </v-chip>
                                <v-chip v-if="item.state=='Procesando'" class="white--text" color="teal" small>
                                    {{ item.state }}
                                </v-chip>
                                <v-chip v-if="item.state=='En espera'" color="" small>
                                    {{ item.state }}
                                </v-chip>
                                <v-chip v-if="item.state=='Completado'" color="success" small>
                                    {{ item.state }}
                                </v-chip>
                                <v-chip v-if="item.state=='Cancelado'" color="grey" small>
                                    {{ item.state }}
                                </v-chip>
                                <v-chip v-if="item.state=='Reembolsado'" class="white--text" color="deep-orange" small>
                                    {{ item.state }}
                                </v-chip>
                                <v-chip v-if="item.state=='Fallido'" color="error" small>
                                    {{ item.state }}
                                </v-chip>
                                <v-chip v-if="item.state=='WhatsApp'" class="white--text" color="#36a884" small>
                                    {{ item.state }}
                                </v-chip>
                                <div v-if="item.state=='Pendiente'" class="d-flex">
                                    <v-btn
                                        small
                                        color="success"
                                        class="mr-2 text-capitalize"
                                        :loading="loading2"
                                        @click="aceptarRechazar('aceptar', item.id)"
                                    >Aceptar</v-btn>
                                    <v-btn
                                        small
                                        color="error"
                                        class="text-capitalize"
                                        :loading="loading2"
                                        @click="aceptarRechazar('rechazar', item.id)"
                                    >Rechazar</v-btn>
                                </div>
                            </td> -->
                            <td>{{ item.date }}</td>
                            <td>{{ item.full_name }}</td>
                            <td>{{item.phone_number }}</td>
                            <td>{{ item.type_order }}</td>
                            <template v-for="(article, i) in item.products">
                            <td class="blue-grey lighten-4" :key="i+1*123">
                                {{ article.name }} x{{ article.pivot.quantity }} {{ money }}{{ article.price }} - {{ article.pivot.extra }}
                            </td>
                            </template>
                            <template v-for="(temp, j) in (maxProds -item.products.length)">
                            <td class="blue-grey lighten-4" :key="j+1*321">-</td>
                            </template>
                            <td class="text-right">
                                {{ money }} {{ item.total }}
                            </td>
                        </tr>
                    </tbody>
                    </template>
                </v-simple-table>

                <!--
                    presales
                 -->
                <v-simple-table v-if="typeResp=='presales'">
                    <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left">
                                #
                            </th>
                            <th class="text-left">
                                Estado
                            </th>
                            <th class="text-left">
                                Acciones
                            </th>
                            <th class="text-left" style="min-width:150px">
                                Fecha
                            </th>
                            <th class="text-left">
                                Cliente
                            </th>
                            <th class="text-left">
                                Celular
                            </th>
                            <th class="text-left" style="min-width:200px">
                                Dirección de entrega
                            </th>
                            <th class="text-left">
                                Método de pago
                            </th>
                            <th class="text-left blue-grey lighten-4" style="min-width:200px" v-for="(art, j) in maxProds" :key="j">
                                Artículo {{ j+1 }}
                            </th>
                            <th class="text-left">
                                Pagado
                            </th>
                            <th class="text-left">
                                Por pagar
                            </th>
                            <th class="text-right" style="min-width:100px">
                                total
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in listOrders" :key="index">
                            <td>{{ item.number }}</td>
                            <td>
                                <div style="width:150px">
                                    <v-select
                                        :items="itemsStates"
                                        label="Estado"
                                        outlined
                                        dense
                                        hide-details
                                        v-model="item.state"
                                        @change="updateState(item.state, item.id)"
                                    >
                                        <template v-slot:selection="data">
                                            <span :class="{
                                                'primary--text': data.item=='Nuevo',
                                                'purple--text': data.item=='En tránsito',
                                                'green--text': data.item=='Completado',
                                                'blue--text': data.item=='Pendiente',
                                                'red--text': data.item=='Fallido',
                                                'deep-orange--text': data.item=='Reembolsado',
                                            }">
                                                {{ data.item }}
                                            </span>
                                        </template>
                                    </v-select>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex">
                                    <v-btn
                                        icon
                                        :href="`/admin/print-presale/${item.id}`"
                                        target="_blank"
                                    >
                                        <v-icon color="grey">
                                            mdi-printer
                                        </v-icon>
                                    </v-btn>
                                    <v-btn
                                        icon
                                        :href="`/admin/presale/${item.id}`"
                                        target="_blank"
                                        v-if="item.state==='Pendiente'"
                                    >
                                        <v-icon color="grey">
                                            mdi-pencil
                                        </v-icon>
                                    </v-btn>
                                </div>
                            </td>
                            <td>{{ item.date }}</td>
                            <td>{{ item.client.name }} {{ item.client.lastname }}</td>
                            <td>{{ item.client.phone }}</td>
                            <td>{{ item.address_map }} {{ item.address_clarification }} <a :href="`https://www.google.com/maps/place/${item.lat_map},${item.lng_map}`" target="_blank">Ver</a></td>
                            <td>
                                <span v-if="item.payment_method == 'cash_payment'">Pago Contraentrega</span>
                                <span v-if="item.payment_method == 'bank_payment'">Pago Qr/Transferencia Bancaria</span>
                                <span v-if="item.payment_method == 'card_payment'">Pago tarjeta de débito/crédito</span>
                                <span v-if="item.payment_method == 'bank_ven'">Pago por PagomóvilBDV</span>
                            </td>
                            <template v-for="(article, i) in item.products">
                            <td class="blue-grey lighten-4"pizzanostrasur :key="i+1*123">
                                {{ article.name }} x{{ article.pivot.quantity }} {{ money }}{{ article.price }} - {{ article.pivot.extra }}
                            </td>
                            </template>
                            <template v-for="(temp, j) in (maxProds -item.products.length)">
                            <td class="blue-grey lighten-4" :key="j+1*321">-</td>
                            </template>
                            <td>{{ money }}{{ item.balance }}</td>
                            <td>{{ money }}{{ item.total-item.balance }}</td>
                            <td class="text-right">
                                {{ money }}{{ item.total }}
                            </td>
                        </tr>
                    </tbody>
                    </template>
                </v-simple-table>

                <div class="text-right py-2" v-html="pageTable"></div>
                <v-pagination
                    v-model="page"
                    :length="totalPage"
                    :total-visible="5"
                    color="primary"
                    @input="changePage"
                    class="my-5"
                ></v-pagination>
            </v-card-text>
        </v-card>

        <v-dialog
            v-model="dialogAddPrd"
            max-width="500"
            scrollable
        >
            <v-card>
                <v-card-title>
                    <v-text-field
                        placeholder="¿Qué te gustaría pedir?"
                        outlined
                        dense
                        hide-details
                        autofocus
                        prepend-inner-icon="mdi-magnify"
                        v-model="txt"
                        :loading="loadSearch"
                        @input="searchProducts"
                    >
                        <template v-slot:append>
                            <v-btn v-show="txt!=''"
                                icon
                                small
                                color="red"
                                class="mt-n1"
                                @click="clearSearch"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                </v-card-title>
                <v-card-text>
                    <v-list>
                        <template v-for="(item, i) in resultProds">
                            <v-list-item :key="i+'li'">
                                <v-list-item-avatar>
                                    <v-img :src="item.banner"></v-img>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title>{{item.name}}</v-list-item-title>
                                    <!-- <v-list-item-subtitle>sdgffdsg</v-list-item-subtitle> -->
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-btn small color="primary" @click="openDetails(item.id)">
                                        Abrir
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                            <v-divider
                                v-if="i < resultProds.length - 1"
                                :key="i+'div'"
                            ></v-divider>
                        </template>
                    </v-list>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialogProd"
            width="500"
            scrollable
            :fullscreen="$vuetify.breakpoint.smAndDown"
            transition="dialog-bottom-transition"
        >
            <v-skeleton-loader
                v-if="loadProd"
                class="white"
                type="card-avatar, article, actions"
            ></v-skeleton-loader>
            <v-card
                v-else
                class="mx-auto"
            >
                <v-overlay
                    absolute
                    :value="overlayProd"
                    opacity=".8"
                >
                    <v-progress-circular
                        indeterminate
                        size="64"
                        color="success"
                    ></v-progress-circular>
                </v-overlay>
                <v-fab-transition>
                    <v-btn
                        absolute
                        right
                        fab
                        small
                        style="top: 10px;"
                        @click="dialogProd=!dialogProd, loadProd=!loadProd"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-fab-transition>

                <v-card-text class="pb-5 px-0">
                    <v-card-title class="pa-0">
                        <v-carousel
                            height="auto"
                            class="simple-carousel"
                            :show-arrows="(galleryProd.length<=0)?false:true"
                            hide-delimiters
                            style="min-height: 250px;"
                            v-if="bannerProd != 'none'"
                        >
                            <v-carousel-item
                                class="white"
                                contain
                            >
                                <v-img
                                    :src="bannerProd"
                                    :lazy-src="bannerProd"
                                >
                                    <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                        >
                                            <v-progress-circular
                                                indeterminate
                                                color="primary"
                                            ></v-progress-circular>
                                        </v-row>
                                    </template>
                                </v-img>
                            </v-carousel-item>
                            <v-carousel-item
                                v-for="(img, j) in galleryProd" :key="j"
                                class="white"
                                contain
                            >
                                <v-img
                                    :src="img.img"
                                    :lazy-src="img.img"
                                >
                                    <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                        >
                                            <v-progress-circular
                                                indeterminate
                                                color="primary"
                                            ></v-progress-circular>
                                        </v-row>
                                    </template>
                                </v-img>
                            </v-carousel-item>
                        </v-carousel>
                        <div class="px-4 py-2" style="width:100%">
                            {{ nameProd }}
                        </div>
                    </v-card-title>

                    <div class="px-5 mb-5" v-if="descriptionProd" :style="{'color':contentColor, 'fontSize':'16px'}" v-html="descriptionProd"></div>

                    <template v-for="(row, j) in optionsProd">
                        <v-card-title :key="j" class="py-3">
                            {{ row.title }}
                        </v-card-title>
                        <v-alert
                            :key="j+1*150"
                            dense
                            tile
                            outlined
                            type="error"
                            v-if="showAlertRequired && row.isRequired"
                        >Debe seleccionar una opción para continuar</v-alert>
                        <!-- multiple -->
                        <v-list :key="j+10" v-if="row.type == 'multiple'">
                            <!-- select quantity -->
                            <template dense>
                                <v-list-item v-for="(opt) in row.values" :key="opt.name">
                                    <v-list-item-content>
                                        <v-list-item-title>{{ opt.name }}</v-list-item-title>
                                        <v-list-item-subtitle v-if="(+opt.price)>0">{{ money }} (+{{ opt.price }})</v-list-item-subtitle>
                                    </v-list-item-content>

                                    <div class="d-flex align-center mr-3" v-if="row.ifQuantity">
                                        <v-btn
                                            small
                                            :disabled="opt.quantity<=1"
                                            @click="opt.quantity -= 1, changeRespMultiple()"

                                        >
                                            <v-icon dark>
                                                mdi-minus
                                            </v-icon>
                                        </v-btn>
                                        <v-sheet
                                            height="28"
                                            width="60"
                                            class="sheet-cant"
                                        >
                                            {{ opt.quantity }}
                                        </v-sheet>
                                        <v-btn
                                            small
                                            @click="opt.quantity += 1, changeRespMultiple()"
                                        >
                                            <v-icon dark>
                                                mdi-plus
                                            </v-icon>
                                        </v-btn>
                                    </div>

                                    <span :id="`${opt.name.replace(' ', '-')}_${opt.price}`" :data-details="`${opt.name}:${opt.price}:${opt.quantity}`"></span>

                                    <v-list-item-action>
                                        <v-checkbox
                                            v-model="row.tmpVal"
                                            :value="`${opt.name.replace(' ', '-')}_${opt.price}`"
                                            color="primary"
                                            :disabled=" ((row.tmpVal).includes(`${opt.name.replace(' ', '-')}_${opt.price}`)) ? false : ((row.tmpVal).length >= row.select) "
                                            @change="changeRespMultiple"
                                        ></v-checkbox>
                                    </v-list-item-action>
                                </v-list-item>
                            </template>
                        </v-list>
                        <!-- multiple end -->
                        <!-- only -->
                        <v-list :key="j+20" v-if="row.type == 'only'">
                            <v-list-item-group
                                v-model="row.tmpValOnly"
                                active-class=""
                                @change="changeRespOnly"
                            >
                                <v-list-item v-for="(opt) in row.values" :key="opt.name" :value="opt.name+':'+opt.price">
                                    <template v-slot:default="{ active }">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ opt.name }}</v-list-item-title>
                                            <v-list-item-subtitle v-if="(+opt.price)>0">{{ money }} (+{{ opt.price }})</v-list-item-subtitle>
                                        </v-list-item-content>

                                        <v-list-item-action>
                                            <v-icon color="primary" v-if="active">
                                                mdi-circle-slice-8
                                            </v-icon>
                                            <v-icon v-else>
                                                mdi-checkbox-blank-circle-outline
                                            </v-icon>
                                        </v-list-item-action>
                                    </template>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                        <!-- only end -->
                    </template>

                    <v-divider></v-divider>

                    <div class="px-3 pt-5">
                        <v-textarea
                            outlined
                            placeholder="Dato extra"
                            color="primary"
                            rows="3"
                            v-model="dataExtra"
                        ></v-textarea>
                    </div>

                </v-card-text>

                <v-card-actions>
                    <!-- product -->
                    <v-row no-gutters align="center" v-if="typeProd=='product'">
                        <v-col cols="6">
                            <div class="d-flex align-center">
                                <v-btn icon small @click="changePlusAndMinus('minus')" :disabled="quantity<=1">
                                    <v-icon dark>
                                        mdi-minus
                                    </v-icon>
                                </v-btn>
                                <v-text-field
                                    placeholder="Cantidad"
                                    color="primary"
                                    outlined
                                    dense
                                    type="number"
                                    min="1"
                                    step="1"
                                    :max="stock"
                                    hide-details
                                    v-model="quantity"
                                    style="width:100px;max-width:100px;"
                                    @input="changeQuantity($event)"
                                ></v-text-field>
                                <v-btn icon small @click="changePlusAndMinus('plus')" :disabled="quantity>=stock">
                                    <v-icon dark>
                                        mdi-plus
                                    </v-icon>
                                </v-btn>
                            </div>
                        </v-col>
                        <v-col cols="6">
                            <v-btn
                                large
                                block
                                rounded
                                color="primary"
                                class="text-capitalize"
                                @click="addToCart"
                            >
                                <strong>Añadir al pedido {{ money }} {{ (quantity * price) + respMultipleVal + respOnlyVal }}</strong>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- dialog edit -->
        <v-dialog
            v-model="dialogEditPresale"
            max-width="500"
            scrollable
            :fullscreen="$vuetify.breakpoint.smAndDown"
            transition="dialog-bottom-transition"
        >
            <edit-presale v-if="dialogEditPresale" :presale-id="preventId" :slug="slug" :money="money" @close-dialog="dialogEditPresale = false"></edit-presale>
        </v-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            overlay: false,
            loading: false,
            loading2: false,
            tmpSlug: 'http://'+window.location.hostname+'/',
            show: false,
            // list data
            listOrders: [],
            maxProds: 0,
            pageTable: '',
            page: 1,
            totalPage: null,
            // export
            menuInit: false,
            menuEnd: false,
            dateInit: '',
            dateEnd: '',
            //
            orderId: '',
            dialogAddPrd: false,
            txt: '',
            loadSearch: false,
            resultProds: [], //
            overlayProd: false,
            loadProd: true,
            dialogProd: false,
            prodId: '',
            bannerProd: '',
            galleryProd: [],
            nameProd: '',
            typeProd: '',
            descriptionProd: '',
            optionsProd: [],
            quantity: 1,
            price: null,
            stock: 500,
            dataExtra: '',
            respMultiple: [],
            respMultipleVal: 0,
            respOnly: [],
            respOnlyVal: 0,
            showRequired: false,
            showAlertRequired: false,
            // editar preventa
            dialogEditPresale: false,
            preventId: '',
            // actualizar estados
            itemsStates: ['Nuevo', 'Pendiente', 'En tránsito', 'Completado', 'Reembolsado', 'Fallido'],
        };
    },
    props: ['money', 'typeResp', 'slug'],
    mounted() {
        this.getListOrders()
    },
    methods: {
        /**
         * List categories
         */
        changePage (event) {
            this.page = event;
            this.getListOrders()
        },
        async getListOrders () {
            this.listOrders = []
            this.overlay = true
            await axios.post(`/admin/list-myorders?page=${this.page}`, {type: this.typeResp})
            .then(response => {
                // console.log(response)
                response.data[0].data.forEach(element => {
                    const d = new Date(element.created_at)
                    element.date = d.getDate() +'-'+ (d.getMonth()+1) +'-'+ d.getFullYear() +'  '+ d.getHours()+':'+d.getMinutes()
                    this.listOrders.push(element)
                });
                // this.listOrders = response.data[0].data
                this.totalPage = response.data[0].last_page
                this.pageTable = `Mostrando <strong>${response.data[0].from??0} - ${response.data[0].to??0}</strong> de un total de <strong>${response.data[0].total}</strong>`

                this.maxProds = response.data[1]

                this.overlay = false
                this.show = true
            })
            .catch(error => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.overlay = false
            })
        },
        /**
         * scroll
         */
        scroll_left() {
        let content = document.querySelector(".v-data-table__wrapper");
            content.scrollLeft -= 100;
        },
        scroll_right() {
            let content = document.querySelector(".v-data-table__wrapper");
            content.scrollLeft += 100;
        },

        /**
         * Aceptar/rechazar
         */
        async aceptarRechazar(type, id) {
            this.loading2 = true
            await axios.post('/admin/accept-reject', {type:type, id:id})
            .then((response) => {
                // console.log(response)
                if (response.data == 'ok') {
                    this.$alert('', 'Cambio de estado con éxito.', 'success', {confirmButtonText: 'Continuar'})
                    this.getListOrders()
                }
                this.loading2 = false
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loading2 = false
            })
        },

        /**
         * añadir productos
         */
        addProducts(id) {
            this.orderId = id
            this.dialogAddPrd = true
        },
        clearSearch() {
            this.txt = ''
            this.getDataStore()
            this.dialogSearch = false
        },
        searchProducts(event) {
            if (event!='') {
                this.loadSearch = true
                setTimeout(() => {
                    this.getDataStore(event)
                }, 500);
            } else {
                this.resultProds = []
            }
        },
        async getDataStore(txt='') {
            await axios.post('/seller/search-product', {search: txt})
            .then((response) => {
                // console.log(response.data);
                this.resultProds = response.data
                this.loadSearch = false
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loadSearch = false
            })
        },

        changeRespMultiple() {
            this.verifyRequireds()
            setTimeout(() => {
                var tmpListComplements = []
                this.optionsProd.forEach(element => {
                    element.tmpVal.forEach(val => {
                        const selectedId = document.getElementById(val)
                        const dataSelected = selectedId.getAttribute('data-details')
                        tmpListComplements.push(dataSelected)
                    });
                });
                // console.log(tmpListComplements);
                this.respMultipleVal = 0
                if (tmpListComplements.length > 0) {
                    tmpListComplements.forEach(el => {
                        // console.log(el);
                        let valSelected = el.split(':')
                        let tmpPrice = (+valSelected[1]) * (+valSelected[2])
                        this.respMultipleVal += tmpPrice
                    });
                }
                this.respMultiple = tmpListComplements
            }, 500);
        },
        changeRespOnly() {
            this.verifyRequireds()
            const tmpListOnly = []
            this.optionsProd.forEach(element => {
                if (element.tmpValOnly) {
                    tmpListOnly.push(element.tmpValOnly)
                }
            });

            this.respOnlyVal = 0
            if (tmpListOnly.length > 0) {
                tmpListOnly.forEach(el => {
                    let tmpPrice = +(el.split(':')[1])
                    this.respOnlyVal += tmpPrice
                });
            }
            // console.log(tmpListOnly);
            this.respOnly = tmpListOnly
        },
        verifyRequireds() {
            for (let i = 0; i < this.optionsProd.length; i++) {
                const element = this.optionsProd[i];
                if (element.isRequired) {
                    if (element.type == 'multiple') this.showRequired = (element.tmpVal.length<=0)
                    if (element.type == 'only') this.showRequired = (element.tmpValOnly==undefined)
                }
                if (this.showRequired) break
            }
        },
        openDetails(id) {
            this.optionsProd = []
            this.loadProd = true
            this.dialogProd = true
            axios.get(`/show-product/${id}`)
            .then((response) => {
                // console.log(response);
                this.prodId = response.data.id
                const tmpBanner = response.data.banner.split('/');
                this.bannerProd = (tmpBanner.slice(-1)[0]!='img-default.png') ? response.data.banner : 'none'
                this.galleryProd = response.data.gallery
                this.nameProd = response.data.name
                this.typeProd = response.data.type
                this.descriptionProd = response.data.description
                if (response.data.complements.length > 0) {
                    response.data.complements.forEach(element => {
                        var tmpVal = JSON.parse(element.values)
                        var multiRequired = []
                        var onlyRequired = undefined
                        tmpVal.forEach(val => {
                            val.quantity = 1
                        });
                        if (element.type == 'multiple') {
                            for (let i = 0; i < tmpVal.length; i++) {
                                const val = tmpVal[i];
                                if (element.required) {
                                    // multiRequired.push(`${val.name}:${val.price}:${val.quantity}`)
                                    multiRequired.push(`${val.name.replace(' ', '-')}_${val.price}`)
                                    setTimeout(() => {
                                        this.changeRespMultiple()
                                    }, 300);
                                    break
                                }
                            }
                        }
                        if (element.type == 'only') {
                            for (let i = 0; i < tmpVal.length; i++) {
                                const val = tmpVal[i];
                                if (element.required) {
                                    onlyRequired = val.name+':'+val.price
                                    setTimeout(() => {
                                        this.changeRespOnly()
                                    }, 300);
                                    break
                                }
                            }
                        }
                        // const selectRequired = `${opt.name.replace(' ', '-')}_${opt.price}`
                        this.optionsProd.push({
                            title: element.title,
                            type: element.type,
                            values: tmpVal,
                            select: element.select,
                            tmpVal: multiRequired,
                            tmpValOnly: onlyRequired,
                            ifQuantity: element.quantity,
                            quantity: 1,
                            isRequired: (element.required)?true:false
                        })
                        if (element.required) {
                            this.showRequired = true
                        }
                    });
                }
                this.price = (response.data.special_price) ? response.data.special_price : response.data.price
                this.quantity = 1

                setTimeout(() => {
                    this.loadProd = false
                }, 800);
            })
            .catch((error) => {
                console.log(error);
            })
        },
        // chabge quantity
        changeQuantity(event) {
            if (+event > this.stock) {
                this.$fire({
                    title: 'Agotado',
                    text: `Stock agotado, solo queda ${this.stock} productos en almacén`,
                    type: 'error',
                    confirmButtonText: 'Entendido',
                    confirmButtonColor: '#dd730f ',
                    cancelButtonColor: '#f44336',
                    reverseButtons: true,
                    showCancelButton: false
                }).then(resp => {
                    if (resp.value) {
                        this.quantity = this.stock
                        this.calcTotal()
                    }
                })
            }
            this.calcTotal()
        },
        // change plus and minus
        changePlusAndMinus(type) {
            var tmpImport = 0
            switch (type) {
                case 'minus':
                    tmpImport = ((+this.price) * ((+this.quantity)-1))
                    if (tmpImport < 0) {
                        this.$notify.error('Error, el importe esperado no debe ser menor a cero, revise el campo descuento por favor.')
                        return
                    }
                    this.quantity = (+this.quantity) - 1
                    break
                case 'plus':
                    tmpImport = ((+this.price) * ((+this.quantity)+1))
                    if (tmpImport < 0) {
                        this.$notify.error('Error, el importe esperado no debe ser menor a cero, revise el campo descuento por favor.')
                        return
                    }
                    this.quantity = (+this.quantity) + 1
                    break
                default:
                    break
            }
            this.changeQuantity(this.quantity)
            this.calcTotal()
        },
        calcTotal() {
            // this.total = 0
            // this.listProdSelected.forEach(p => {
            //     this.total+=(p.price * p.quantity) - p.discount
            // });
            // this.data.payTotal = this.total.toFixed(2)
        },
        addToCart() {
            this.$fire({
                title: 'Añadir al pedido',
                text: `El producto ${this.nameProd} se agregará al pedido, ¿desea continuar?`,
                type: 'info',
                confirmButtonText: 'Continuar',
                confirmButtonColor: '#dd730f ',
                cancelButtonColor: '#f44336',
                reverseButtons: true,
                showCancelButton: false,
            }).then(resp => {
                if (resp.value) {
                    const cart = {
                            prodId: this.prodId,
                            name: this.nameProd,
                            // price: this.price,
                            price: (this.quantity * this.price) + this.respMultipleVal + this.respOnlyVal,
                            quantity: this.quantity,
                            extra: this.dataExtra,
                            complements: {
                                multi: this.respMultiple,
                                only: this.respOnly
                            }
                        };
                    axios.post(`/seller/add-product-order/${this.orderId}`, cart)
                    .then((response) => {
                        // console.log(response);
                        if (response.data == 'ok') {
                            this.dialogProd = false;
                            this.txt = '';
                            this.resultProds = [];
                            this.$notify.success('Se agrego el producto al pedido con exito.');
                            this.getListOrders()
                        }
                    })
                    .catch((error) => {
                        // console.log(error);
                        if (error.response.status == 404 || error.response.status == 500) {
                            this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                        }
                    })
                }
            })
        },

        /**
         * update state
         */
        async updateState(val, id) {
            this.loading = true
            await axios.post(`/admin/up-presale/${id}`, {state: val})
            .then((response) => {
                // console.log(response);
                if (response.data === 'ok') {
                    this.$notify.success('Estado actualizado con éxito.')
                }
                this.loading = false
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loading = false
            });
        },
    },
}
</script>
